import WorkList from './workList';

import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// import 'photoswipe/style.css';
class Visuello {

    constructor() {

        this.header = document.querySelector('.site-header');
        this.menuToggleButton = document.querySelector('.toggle-menu');
        this.categorySelectorElement = document.querySelector('.category-selector');

        const workList = new WorkList();

        this.registerEvents();
        this.categorySelector();
        this.registerWaypoints();
        this.collectionsLayout();
        this.registerLazyImageWaypoints();

    }

    collectionsLayout() {

        const collectionGrid = document.querySelector('.collection__grid');
        const pswpElement = document.querySelector('.pswp');
        const collectionGridLinks = document.querySelectorAll('.collection__grid-link');
        if (collectionGrid) {

            let msnry = new Masonry(collectionGrid, {
                columnWidth: '.grid-sizer',
                itemSelector: '.collection__grid-item',
                percentPosition: true,
                transitionDuration: '0.2s',
                initLayout: false,
            });

            msnry.on('layoutComplete', () => {
                collectionGrid.classList.add('collection__grid--loaded')
            })

            msnry.layout()

            let pswpArr = []
            collectionGridLinks.forEach((link, index) => {

                pswpArr.push({
                    msrc: link.dataset.msrc,
                    src: link.getAttribute('href'),
                    title: link.dataset.caption,
                    w: link.dataset.width,
                    h: link.dataset.height,
                })

                link.addEventListener('click', event => {

                    event.preventDefault()

                    const lightbox = new PhotoSwipeLightbox({
                        gallery: '.collection__grid',
                        children: 'figure a',
                        pswpModule: PhotoSwipe,
                        padding: { top: 30, bottom: 30, left: 50, right: 50 },
                        bgOpacity: 0.95
                    });
                    lightbox.init();

                })
            })
        }
    }

    registerLazyImageWaypoints() {
        setTimeout(() => {
            const waypoints = $('img.lazyload').waypoint({
                handler: function () {

                    let image = $(this.element);
                    if (!image.hasClass('loaded')) {
                        image.attr('srcset', image.attr('data-srcset')).attr('data-srcset', '').addClass('loaded');
                    }

                },
                offset: '125%'
            });
        }, 250)
    }

    registerWaypoints() {
        setTimeout(() => {

            const fadeIns = $('.fade-in-element').waypoint({
                handler: function (direction) {
                    if (direction === 'down') {
                        $(this.element).addClass('visible');


                    } else {
                        $(this.element).removeClass('visible');
                    }
                },
                offset: '85%'
            });

            const workList = $('.work-list').waypoint({
                handler: function (direction) {
                    if (direction === 'down') {
                        document.body.classList.add('dark-mode')
                    } else {
                        document.body.classList.remove('dark-mode')
                    }
                },
                offset: '100px'
            });

            const contactPage = $('.contact-page').waypoint({
                handler: function (direction) {
                    if (direction === 'down') {
                        document.body.classList.remove('dark-mode')
                    } else {
                        document.body.classList.add('dark-mode')
                    }
                },
                offset: '50%'
            });


        }, 250)
    }

    categorySelector() {

        if (!this.categorySelectorElement) {
            return;
        }

        this.categorySelectorElement.children[0].addEventListener('click', event => {
            event.stopPropagation();
            this.categorySelectorElement.classList.toggle('open-dropdown');
        });

        document.addEventListener('click', event => {
            this.categorySelectorElement.classList.remove('open-dropdown');
        })
    }


    toggleNavigation() {

        if (this.header.classList.contains('open-navigation')) {
            this.header.classList.remove('open-navigation');
            this.menuToggleButton.innerHTML = this.menuToggleButton.dataset.open;
        } else {
            this.header.classList.add('open-navigation');
            this.menuToggleButton.innerHTML = this.menuToggleButton.dataset.close;
        }
    }

    registerEvents() {

        window.addEventListener('scroll', event => {

            let header = document.querySelector('.site-header'),
                offset = 0,
                scrollTop = window.pageYOffset;

            if (scrollTop > offset) {
                header.classList.add('solid');
            } else {
                header.classList.remove('solid');
            }

        });

        this.menuToggleButton.addEventListener('click', () => { this.toggleNavigation() });

    }
}

const site = new Visuello();

